export interface FacebookCatalogOption {
  readonly value: string;
  readonly label: string;
}

/** Publish target values for Facebook destination defaults (`FacebookDefaultPublishTarget` on backend). */
export const FACEBOOK_PUBLISH_TARGETS: readonly FacebookCatalogOption[] = Object.freeze([
  { value: 'PageVideo', label: 'Page video' },
  { value: 'PageReel', label: 'Page reel' },
]);

/**
 * Static Meta `content_category` enum (`FacebookContentCategory` on backend).
 * No per-Page catalog API — unlike YouTube video categories.
 */
export const FACEBOOK_CONTENT_CATEGORIES: readonly FacebookCatalogOption[] = Object.freeze([
  { value: 'BEAUTY_FASHION', label: 'Beauty & Fashion' },
  { value: 'BUSINESS', label: 'Business' },
  { value: 'CARS_TRUCKS', label: 'Cars & Trucks' },
  { value: 'COMEDY', label: 'Comedy' },
  { value: 'CUTE_ANIMALS', label: 'Cute Animals' },
  { value: 'ENTERTAINMENT', label: 'Entertainment' },
  { value: 'FAMILY', label: 'Family' },
  { value: 'FOOD_HEALTH', label: 'Food & Health' },
  { value: 'HOME', label: 'Home' },
  { value: 'LIFESTYLE', label: 'Lifestyle' },
  { value: 'MUSIC', label: 'Music' },
  { value: 'NEWS', label: 'News' },
  { value: 'POLITICS', label: 'Politics' },
  { value: 'SCIENCE', label: 'Science' },
  { value: 'SPORTS', label: 'Sports' },
  { value: 'TECHNOLOGY', label: 'Technology' },
  { value: 'VIDEO_GAMING', label: 'Video Gaming' },
  { value: 'OTHER', label: 'Other' },
]);
